const spiderTypes = {
  TEST: "TEST",

  GET_MARCAS: "GET_MARCAS",
  GET_MARCAS_SUCCESS: "GET_MARCAS_SUCCESS",
  GET_MARCAS_FAILED: "GET_MARCAS_FAILED",
  GET_MARCAS_VEHICLETYPE: "GET_MARCAS_VEHICLETYPE",
  GET_MARCAS_VEHICLETYPE_SUCCESS: "GET_MARCAS_VEHICLETYPE_SUCCESS",
  GET_MARCAS_VEHICLETYPE_FAILED: "GET_MARCAS_VEHICLETYPE_FAILED",

  GET_BRAND_BY_MODEL: "GET_BRAND_BY_MODEL",
  GET_BRAND_BY_MODEL_SUCCESS: "GET_BRAND_BY_MODEL_SUCCESS",
  GET_BRAND_BY_MODEL_FAILED: "GET_BRAND_BY_MODEL_FAILED",

  GET_MODELOS: "GET_MODELOS",
  GET_MODELOS_SUCCESS: "GET_MODELOS_SUCCESS",
  GET_MODELOS_FAILED: "GET_MODELOS_FAILED",
  GET_MODELOS_VEHICLETYPE: "GET_MODELOS_VEHICLETYPE",
  GET_MODELOS_VEHICLETYPE_SUCCESS: "GET_MODELOS_VEHICLETYPE_SUCCESS",
  GET_MODELOS_VEHICLETYPE_FAILED: "GET_MODELOS_VEHICLETYPE_FAILED",

  GET_HOMOLOGATION: "GET_HOMOLOGATION",
  GET_HOMOLOGATION_SUCCESS: "GET_HOMOLOGATION_SUCCESS",
  GET_HOMOLOGATION_FAILED: "GET_HOMOLOGATION_FAILED",

  GET_HOMOLOGATED_CARS: "GET_HOMOLOGATED_CARS",
  GET_HOMOLOGATED_CARS_SUCCESS: "GET_HOMOLOGATED_CARS_SUCCESS",
  GET_HOMOLOGATED_CARS_FAILED: "GET_HOMOLOGATED_CARS_FAILED",

  GET_HOMOLOGATED: "GET_HOMOLOGATED",
  GET_HOMOLOGATED_SUCCESS: "GET_HOMOLOGATED_SUCCESS",
  GET_HOMOLOGATED_FAILED: "GET_HOMOLOGATED_FAILED",

  GET_GASTOS: "GET_GASTOS",
  GET_GASTOS_SUCCESS: "GET_GASTOS_SUCCESS",
  GET_GASTOS_FAILED: "GET_GASTOS_FAILED",

  GET_PLAZOS: "GET_PLAZOS",
  GET_PLAZOS_SUCCESS: "GET_PLAZOS_SUCCESS",
  GET_PLAZOS_FAILED: "GET_PLAZOS_FAILED",

  GET_PRODUCTS: "GET_PRODUCTS",
  GET_PRODUCTS_SUCCESS: "GET_PRODUCTS_SUCCESS",
  GET_PRODUCTS_FAILED: "GET_PRODUCTS_FAILED",

  POST_CALCULATE_FEE: "POST_CALCULATE_FEE",
  POST_CALCULATE_FEE_SUCCESS: "POST_CALCULATE_FEE_SUCCESS",
  POST_CALCULATE_FEE_FAILED: "POST_CALCULATE_FEE_FAILED",

  GET_TYPE_PRODUCTS: "GET_TYPE_PRODUCTS",
  GET_TYPE_PRODUCTS_SUCCESS: "GET_TYPE_PRODUCTS_SUCCESS",
  GET_TYPE_PRODUCTS_FAILED: "GET_TYPE_PRODUCTS_FAILED",

  GET_TASA_VFMG: "GET_TASA_VFMG",
  GET_TASA_VFMG_SUCCESS: "GET_TASA_VFMG_SUCCESS",
  GET_TASA_VFMG_FAILED: "GET_TASA_VFMG_FAILED",

  GET_REGISTRATION: "GET_REGISTRATION",
  GET_REGISTRATION_SUCCESS: "GET_REGISTRATION_SUCCESS",
  GET_REGISTRATION_FAILED: "GET_REGISTRATION_FAILED",

  GET_CES_SPIDER: "GET_CES_SPIDER",
  GET_CES_SPIDER_SUCCESS: "GET_CES_SPIDER_SUCCESS",
  GET_CES_SPIDER_FAILED: "GET_CES_SPIDER_FAILED",

  GET_MONTHS: "GET_MONTHS",
  GET_MONTHS_SUCCESS: "GET_MONTHS_SUCCESS",
  GET_MONTHS_FAILED: "GET_MONTHS_FAILED",

  POST_INYECTION_TRINIDAD: "POST_INYECTION_TRINIDAD",
  POST_INYECTION_TRINIDAD_SUCCESS: "POST_INYECTION_TRINIDAD_SUCCESS",
  POST_INYECTION_TRINIDAD_FAILED: "POST_INYECTION_TRINIDAD_FAILED",

  GET_TYPE_PARAMS: "GET_TYPE_PARAMS",
  GET_TYPE_PARAMS_SUCCESS: "GET_TYPE_PARAMS_SUCCESS",
  GET_TYPE_PARAMS_FAILED: "GET_TYPE_PARAMS_FAILED",
}

export { spiderTypes };